import { isEmptyArr } from '@utils/index';

import { ConstructorHeaderType } from './context/context';
import { constructorFilterValues } from './constants';
import { useConstructor } from './hooks';
import {
  ConstructorFieldType,
  ConstructorFilterKeys,
  ConstructorHeaderKeys,
  OneConstructorFieldType,
  OneConstructorType,
  UploadConstructorValueType
} from './schema';

export function tableNumber({ index, page = 1, size = 10 }: { index: number; page: number; size?: number }) {
  return ((page || 1) - 1) * size + (index + 1);
}

export function generateFieldKeys(data: OneConstructorType) {
  const keys: ConstructorFilterKeys[] = [];

  Object.keys(data)?.forEach(key => {
    if (typeof data?.[key as never] === 'boolean') {
      keys.push(key as never);
    }
  });

  return keys;
}

export function generateConstructorFilters() {
  const {
    createOrUpdate: { dominant }
  } = useConstructor();

  const filters: ({
    filterKey: string;
  } & UploadConstructorValueType)[] = [];

  Object.keys(constructorFilterValues)?.forEach(key => {
    const item = constructorFilterValues?.[key as ConstructorFilterKeys];

    if (item?.dominants?.includes(dominant)) {
      filters.push({
        filterKey: key,
        ...item
      });
    }
  });

  return filters;
}

export function generateExcelHeaders(n?: number) {
  const headers = [];
  let i = 0;

  const count = n && n >= 10 ? n : 10;

  while (headers.length < count) {
    let header = '';
    let temp = i;

    while (temp >= 0) {
      header = String.fromCharCode((temp % 26) + 65) + header;
      temp = Math.floor(temp / 26) - 1;
    }
    headers.push(header);

    i += 1;
  }

  return headers;
}

export function generatePayloadHeaders(headers?: ConstructorHeaderType[]) {
  const customFieldKeys = ['contractCustomFieldsHeader', 'flatCustomFieldsHeader', 'paymentCustomFieldsHeader'];

  // @ts-expect-error
  let obj: {
    [K in ConstructorHeaderKeys]: OneConstructorFieldType;
  } = {};

  headers?.forEach(({ key, ...arg }, index) => {
    const fieldKey = key.split('_')?.[0];

    if (customFieldKeys.includes(fieldKey)) {
      obj = {
        ...obj,
        [fieldKey]: [...((obj?.[fieldKey as keyof typeof obj] as never) || []), { ...arg, order: index + 1 }]
      };
    } else {
      obj = {
        ...obj,
        [key]: { ...arg, order: index + 1 }
      };
    }
  });

  return obj;
}

export function generatePayloadFilters(filters?: `${string}Filter`[]) {
  // @ts-expect-error
  let obj: { [F in ConstructorFilterKeys]: boolean } = {};

  filters?.forEach(key => {
    obj = {
      ...obj,
      [key]: true
    };
  });

  return obj;
}

export function checkFilters(allFilters?: ConstructorFieldType, filters?: `${string}Filter`[]) {
  const noCheckFilters: `${string}Filter`[] = [];

  if (allFilters || filters) {
    Object.keys(allFilters || {})?.forEach(key => {
      if (key?.includes('Filter') && !filters?.includes(key as never)) {
        noCheckFilters.push(key as never);
      }
    });
  }

  return {
    isAccept: isEmptyArr(noCheckFilters),
    noCheckFilters
  };
}
